module.exports = __webpack_public_path__ + "img/111.2f875fa7.svg";